
const raf = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame || window.oRequestAnimationFrame || (loop => setTimeout( loop, 16 ));
const easings = {
    linear: t => t,
    easeInQuad: t => t * t,
    easeOutQuad: t => t * (2 - t),
    easeInOutQuad: t => t < .5 ? 2 * t * t : -1 + (4 - 2 * t) * t ,
    easeInCubic: t => t * t * t,
    easeOutCubic: t => (--t) * t * t + 1,
    easeInOutCubic: t => t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1,
    easeInQuart: t => t * t * t * t,
    easeOutQuart: t => 1 - (--t) * t * t * t,
    easeInOutQuart: t => t < .5 ? 8 * t * t * t * t : 1 - 8 * (--t) * t * t * t,
    easeInQuint: t => t * t * t * t * t,
    easeOutQuint: t => 1 + (--t) * t * t * t * t,
    easeInOutQuint: t => t < .5 ? 16 * t * t * t * t * t : 1 + 16 * (--t) * t * t * t * t
}; // Easing Functions - inspired from http://gizma.com/easing/


export default function animateLoop( cb, duration, ease ){
    let start;
    const loop = () => {

        let now = +new Date();
        if (!start) { start = now };
        let delta = now - start;

        if( ease && !easings[ ease ] ){ console.error( `"${ ease }" isnt a supported easing, please choose from the following list: ${ Object.keys( easings ).join(', ') }` ) };
        cb( easings[ ease || 'linear' ]( Math.min( 1, delta / duration ) ), !( delta < duration ) );
        delta < duration ? raf( loop ) : ( start = null ) ;

    };
    raf( loop );
};



// WEBPACK FOOTER //
// src/client/helpers/common/animateLoop.js